import React, { Component } from "react"
import { connect } from "react-redux"
import { Col, Row, Button, Table, Alert, Input, FormGroup, Label, Modal, ModalBody, ModalHeader} from "reactstrap";
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import { getStartups } from "../../store/startups/actions"


class StartupListModal extends Component {

    constructor(props) {
      super(props);

      this.state = {
          startup: null,
          addMore: false,
          mandatory_kpi: [],
          error: "",
          show: true,
          success: "",
      }
    }

    componentDidMount(){
        const {startup} = this.props;
        console.log("startup: ", this.props, startup);
        this.setState({startup: startup, mandatory_kpi: startup.mandatory_standard_kpi || []});
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        console.log(nextProps);
        let mandatory_kpi = nextProps.startup?.mandatory_standard_kpi || [];
        this.setState({ error: nextProps.error, success: nextProps.success, mandatory_kpi: mandatory_kpi});
    }

    toggleAddMore = () => {
       this.setState({addMore: !this.state.addMore});
    }

    onClose = () => {
        this.setState({show: !this.state.show});
        this.props.onClose();
    }

    handleRemoveKPI = (kpi_type, name) => {
        console.log("removing kpi");
        const { onRemoveKPI } = this.props;
        let kpi = {startup_id: this.state.startup?.id, kpi_type: kpi_type, name: name};
        if(this.state.startup?.id) onRemoveKPI(kpi);
    }

    handleCheck = (name) => {
        console.log(name);
        const {onSetKPIMandatory} = this.props;
        let mandatory_kpi = this.state.mandatory_kpi || [], is_mandatory = false;
        if(mandatory_kpi.includes(name)){
             mandatory_kpi = mandatory_kpi.filter(k => k !== name);
        } else {
            mandatory_kpi.push(name);
            is_mandatory = true;
        }

        onSetKPIMandatory({kpi_name: name, startup_id: this.state.startup?.id, is_mandatory: is_mandatory});
        this.setState({mandatory_kpi: mandatory_kpi});
    }

    isChecked = (v) => {
        console.log(this.state.mandatory_kpi, v);
        return this.state.mandatory_kpi.includes(v);
    }

    render() {
        const render_kpis = (kpis, kpi_type) => {
            let canRemove = kpi_type === "additional" || kpi_type === "extra";
            return <Table bordered>
              <thead>
                  <tr>
                    {
                      kpis.map((c, i) => (
                        <th key={i}> KPI Name {!canRemove && <span>| Mandatory</span>}</th>
                      ))
                    }
                  </tr>
              </thead>
              <tbody>
                  <tr>
                    {
                      kpis.map((c, i) => (
                        <td key={i}>
                            <div className="d-flex gap-3 justify-content-between">
                              <Label className="text-capitalize">
                                {c}
                              </Label>
                              {
                                 !canRemove && <FormGroup check>
                                     <Label check>
                                        <Input type="checkbox" title="Is Mandatory ?" onChange={() => { this.handleCheck(c) }} checked={this.isChecked(c)} />
                                     </Label>
                                 </FormGroup>
                              }
                              {
                                 canRemove && <Link className="text-danger" to="#">
                                   <i
                                     className="mdi mdi-close-box-outline font-size-22"
                                     title="Click Remove this KPI for startup"
                                     id="rm_kpi"
                                     onClick={() => this.handleRemoveKPI(kpi_type, c)}
                                   ></i>
                                 </Link>
                              }
                            </div>
                        </td>
                      ))
                    }
                  </tr>
              </tbody>
            </Table>
        }

        return (
                 <div className="page-content">
                    <Modal isOpen={this.state.show} toggle={() => this.onClose()} size="lg">
                      <ModalHeader toggle={() => this.onClose()} tag="h4">
                        Startup {this.state.startup?.startup_name}
                      </ModalHeader>
                      <ModalBody>
                        <React.Fragment>
                          <Row>
                             <Col>
                               Hello
                             </Col>
                          </Row>
                        </React.Fragment>
                      </ModalBody>
                    </Modal>
            </div>
          )
    }
}

StartupListModal.propTypes = {
  startup: PropTypes.any,
  addMore: PropTypes.bool,
  onAlertClose: PropTypes.func,
  onSetKPIMandatory: PropTypes.func,
  onClose: PropTypes.func,
  className: PropTypes.any,
  onRemoveKPI: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
}

const mapStateToProps = ({ kpi }) => ({
  error: kpi.error,
  success: kpi.success,
})

const mapDispatchToProps = dispatch => ({
  onAlertClose: () => dispatch(closeAlertBox()),
  onRemoveKPI: (kpi) => dispatch(removeKPI(kpi)),
  onSetKPIMandatory: (kpi) => dispatch(setKPIMandatory(kpi)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StartupListModal)
